var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('a',{staticClass:"all-reports-link",attrs:{"href":("#" + _vm.hgReportAnchor)}},[_vm._v("All Reports")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }